import { useEffect, useState } from 'react'
import { isPlural, trDict } from '../../../helpers/Utils'
import { IElementProps } from '../../../types/interfaces'
const GenericRadio = (props: IElementProps) => {
  const [options, setOptions] = useState<number[]>([])

  useEffect(() => {
    const opts: number[] = []
    if (!!props.minimumValue && !!props.maximumValue && !!props.step) {
      if (props.minimumValue < props.maximumValue) {
        if (props.step < 0) {
          setOptions([])
          return
        }
        for (let i = props.minimumValue; i <= props.maximumValue; i += props.step) {
          opts.push(i)
        }
        setOptions(opts)
      }

      if (props.minimumValue > props.maximumValue) {
        if (props.step > 0) {
          setOptions([])
          return
        }
        for (let i = props.minimumValue; i >= props.maximumValue; i += props.step) {
          opts.push(i)
        }
        setOptions(opts)
      }
    }
  }, [props.minimumValue])

  const { lang } = props

  const getUnits = (val: number) => {
    const unit = isPlural(val) ? trDict(lang, props.unitsTrPlural) : trDict(lang, props.unitsTrSingular)
    return unit || props.label
  }

  return (
    <>
      <div className="formGroup">
        <div className="labelTooltip">
          {props.translatedTooltip && (
            <>
              <div className="tooltipArea">
                <i className="icon-info"></i>
                <div className="tooltip">{props.translatedTooltip}</div>
              </div>
            </>
          )}
          <label>{props.label}</label>
        </div>
        <div className="control-group required-highlight">
          <div className="row">
            {options.map((option, i) => (
              <div key={i} className="col-6">
                <label className="control control-radio">
                  {option + ' ' + getUnits(option)}
                  <input
                    disabled={props.formReadOnly || props.disabledInput}
                    type="radio"
                    value={option}
                    name={props.name}
                    checked={option + '' === props.value}
                    onChange={(e) => props.handleChange(props.name, e)}
                  />
                  <div className="control_indicator" />
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}
export default GenericRadio
